// extracted by mini-css-extract-plugin
module.exports = {"categories":"index_categories__J07g3","search":"index_search__d_oGI"};